import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { TerminalType } from "../../../../../../../../../../../services/Api/Organization/types";
import TerminalStatisticsCard from "./TerminalStatisticsCard";

const TerminalsStatisticsRow = () => {
	const organization = useSelector(selectOrganization);
	const isManualLicense = organization.license_type === "MANUAL";

	const getProperty = useCallback(
		(propertyName: string) => {
			if (!organization.properties) return undefined;

			return Object.entries(organization.properties).find((property) => property[0] === propertyName);
		},
		[organization.properties]
	);

	const getAccess = useCallback(
		(accessName: string) => {
			if (!organization.accesses) return undefined;

			return Object.entries(organization.accesses).find((access) => access[0] === accessName);
		},
		[organization.accesses]
	);

	const drawTerminalStatisticsCards = useMemo(() => {
		const posTerminalProperty = getProperty("terminal-pos-limit");
		const posTerminalAccess = getAccess("terminal-pos-limit");
		const terminalMobileProperty = getProperty("terminal-mobile-limit");
		const terminalMobileAccess = getAccess("terminal-mobile-limit");
		const terminalKioskProperty = getProperty("terminal-kiosk-limit");
		const terminalKioskAccess = getAccess("terminal-kiosk-limit");
		const terminalKdsProperty = getProperty("terminal-kds-limit");
		const terminalKdsAccess = getAccess("terminal-kds-limit");
		const terminalCustomerDisplayProperty = getProperty("terminal-customer-display-limit");
		const terminalCustomerDisplayAccess = getAccess("terminal-customer-display-limit");

		return (
			<>
				<TerminalStatisticsCard
					type={TerminalType.POS}
					accessAmount={posTerminalAccess ? Number(posTerminalAccess[1]) || 0 : 0}
					propertyAmount={posTerminalProperty ? Number(posTerminalProperty[1]) || 0 : 0}
					isManualLicense={isManualLicense}
				/>
				<TerminalStatisticsCard
					type={TerminalType.POS_MOBILE}
					accessAmount={terminalMobileAccess ? Number(terminalMobileAccess[1]) || 0 : 0}
					propertyAmount={terminalMobileProperty ? Number(terminalMobileProperty[1]) || 0 : 0}
					isManualLicense={isManualLicense}
				/>
				<TerminalStatisticsCard
					type={TerminalType.KIOSK}
					accessAmount={terminalKioskAccess ? Number(terminalKioskAccess[1]) || 0 : 0}
					propertyAmount={terminalKioskProperty ? Number(terminalKioskProperty[1]) || 0 : 0}
					isManualLicense={isManualLicense}
				/>
				<TerminalStatisticsCard
					type={TerminalType.KDS}
					accessAmount={terminalKdsAccess ? Number(terminalKdsAccess[1]) || 0 : 0}
					propertyAmount={terminalKdsProperty ? Number(terminalKdsProperty[1]) || 0 : 0}
					isManualLicense={isManualLicense}
				/>
				<TerminalStatisticsCard
					type={TerminalType.KDS_NUMBER}
					accessAmount={terminalCustomerDisplayAccess ? Number(terminalCustomerDisplayAccess[1]) ?? 0 : 0}
					propertyAmount={
						terminalCustomerDisplayProperty ? Number(terminalCustomerDisplayProperty[1]) ?? 0 : 0
					}
					isManualLicense={isManualLicense}
				/>
			</>
		);
	}, [getProperty, getAccess]);

	return <div className="terminal-statistics-row">{drawTerminalStatisticsCards}</div>;
};

export default TerminalsStatisticsRow;
